module.exports = __webpack_public_path__ + "media/images/v2/placeholder-b824da400728f29982061c81d1b7e239.jpg";